var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupplier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2098 5.37932L58.624 3.74236L59.5626 2.24298C59.9946 1.55285 60.9012 1.34542 61.5875 1.77986L61.6878 1.84347C62.3741 2.2779 62.5803 3.18966 62.1483 3.87979L61.2098 5.37932Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6017 58.1502L25.3877 56.1157L48.1946 19.7041L51.4086 21.7386L28.6017 58.1502Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0645 24.7055L46.2554 29.9722L51.4087 21.7386L48.1947 19.7041L45.0645 24.7055Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1254 4.22686C49.6431 -2.4087 36.19 -0.390544 28.0388 8.38952C26.3065 10.2553 26.6788 13.242 28.8269 14.6019C30.5811 15.7122 32.8903 15.3069 34.1582 13.6579C41.7225 3.82039 52.8124 -0.402612 60.1254 4.22686Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.125 4.22656C67.4382 8.85589 68.4473 20.7378 62.8981 31.8509C61.9679 33.7138 62.6031 35.9829 64.3572 37.0933C66.5053 38.4531 69.3442 37.4991 70.2679 35.1216C74.6155 23.9335 70.6073 10.862 60.125 4.22656Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1254 4.22656C62.8684 5.9629 60.4758 14.8864 54.7831 25.1278C53.4235 27.5738 54.1971 30.6615 56.5555 32.1543L57.4929 32.7476C59.5317 34.0383 62.2466 33.2607 63.2769 31.0706C68.3972 20.1864 67.2678 8.74771 60.1254 4.22656Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1258 4.22688C52.9836 -0.294408 42.2392 3.62789 34.6946 12.9776C33.1766 14.8588 33.6533 17.6567 35.6922 18.9474L36.6296 19.5407C38.9879 21.0336 42.0908 20.3999 43.696 18.1092C50.4167 8.51874 57.3829 2.49054 60.1258 4.22688Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.125 4.22705C57.4882 2.55787 50.9482 8.06445 44.4755 17.0133C42.4621 19.7971 43.225 23.7166 46.1219 25.5503L47.062 26.1455C49.9589 27.9792 53.803 26.9762 55.4283 23.9466C60.6528 14.2076 62.7621 5.89623 60.125 4.22705Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7628 41.5838H26.0829C25.0191 41.5838 23.9988 41.1589 23.2467 40.4023L8.8673 25.9418C7.74425 24.8124 5.92336 24.8124 4.8003 25.9418C3.67724 27.0712 3.67724 28.9023 4.8003 30.0317L21.0404 46.3637C21.5677 46.9784 22.3474 47.368 23.218 47.368H57.8317C59.4548 47.368 60.7638 46.0158 60.7057 44.3705C60.6503 42.8033 59.3223 41.5838 57.7628 41.5838Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0772 59.4988L25.1452 50.3795C26.3949 49.1228 26.3949 47.0852 25.1452 45.8283C23.8956 44.5716 21.8694 44.5716 20.6196 45.8283L11.5515 54.9475C10.3018 56.2043 10.3018 58.2419 11.5515 59.4988C12.8014 60.7555 14.8275 60.7555 16.0772 59.4988Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 52.6737L18.3382 57.2249L25.1451 50.3795C26.3948 49.1228 26.3948 47.0852 25.1451 45.8283C23.8954 44.5716 21.8693 44.5716 20.6194 45.8283L13.8125 52.6737Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3383 59.4988L55.2703 50.3795C54.0206 49.1228 54.0206 47.0852 55.2703 45.8283C56.52 44.5716 58.5461 44.5716 59.796 45.8283L68.864 54.9475C70.1137 56.2043 70.1137 58.2419 68.864 59.4988C67.6142 60.7555 65.588 60.7555 64.3383 59.4988Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6029 52.6737L62.0772 57.2249L55.2703 50.3795C54.0206 49.1228 54.0206 47.0852 55.2703 45.8283C56.52 44.5716 58.5461 44.5716 59.796 45.8283L66.6029 52.6737Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.95 51.0388H21.4325C19.6651 51.0388 18.2324 49.5979 18.2324 47.8207C18.2324 46.0433 19.6652 44.6025 21.4325 44.6025H59.9499C61.7172 44.6025 63.1499 46.0434 63.1499 47.8207C63.1499 49.5979 61.7174 51.0388 59.95 51.0388Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.937269 31.7466L19.183 50.0954C20.4327 51.3521 22.4589 51.3521 23.7087 50.0954C24.9584 48.8386 24.9584 46.801 23.7087 45.5441L5.46295 27.1955C4.21326 25.9387 2.1871 25.9387 0.937269 27.1955C-0.312423 28.4522 -0.312423 30.4898 0.937269 31.7466Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0003 69.4016V60.318C72.0003 57.4354 69.6767 55.0986 66.8102 55.0986H57.2784C49.3241 55.0986 41.7318 58.4414 36.3363 64.3191L31.6709 69.4016H72.0003Z",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40183 56.7483C14.3263 53.8446 27.0803 55.1673 37.8956 60.4293L39.5927 61.255C47.2901 65 55.9542 66.9656 64.7643 66.9656H68.7167C70.5299 66.9656 71.9999 68.25 71.9999 69.8343C71.9999 71.4186 70.5299 72.703 68.7167 72.703H3.28319C1.46993 72.703 0 71.4186 0 69.8343V59.5119C0 58.224 0.982021 57.094 2.40183 56.7483Z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7169 66.9651H64.7645C55.9544 66.9651 47.2903 64.9995 39.593 61.2545L37.8957 60.4288C31.9466 57.5344 25.4108 55.8333 18.7491 55.3711C15.8828 55.1722 13.4355 57.1634 13.4355 59.6759C13.4355 64.5429 17.9511 68.4884 23.5212 68.4884H71.6159C71.0641 67.5824 69.9735 66.9651 68.7169 66.9651Z",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.8344C0 71.4188 1.46993 72.7031 3.28319 72.7031H68.7168C70.5301 72.7031 72 71.4188 72 69.8344C72 68.25 70.5301 66.9657 68.7168 66.9657H64.7644C59.3386 66.9657 53.9684 66.219 48.845 64.7715H0V69.8344Z",
    fill: "url(#paint18_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 60.1286,
    y1: 3.01223,
    x2: 61.8118,
    y2: 4.06675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 38.0235,
    y1: 38.6538,
    x2: 49.2204,
    y2: 57.2037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 48.4665,
    y1: 31.7464,
    x2: 47.6727,
    y2: 22.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 41.8581,
    y1: 7.91208,
    x2: 63.9644,
    y2: 9.81449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0552BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34BAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 65.9992,
    y1: 11.6396,
    x2: 82.6769,
    y2: 21.0749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0552BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34BAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 59.9014,
    y1: 18.2726,
    x2: 63.1681,
    y2: 21.2115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 44.1422,
    y1: 9.44428,
    x2: 47.7333,
    y2: 14.0309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 51.7554,
    y1: 16.6623,
    x2: 59.3152,
    y2: 18.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0552BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34BAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 32.3328,
    y1: 21.1374,
    x2: 32.3328,
    y2: 48.1874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 15.2773,
    y1: 49.573,
    x2: 20.8037,
    y2: 55.0683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 17.807,
    y1: 53.2079,
    x2: 21.0896,
    y2: 49.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "#734A23",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603813"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 65.1323,
    y1: 49.573,
    x2: 59.606,
    y2: 55.0683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 62.6084,
    y1: 53.2079,
    x2: 59.3258,
    y2: 49.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "#734A23",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603813"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 40.6912,
    y1: 43.4588,
    x2: 40.6912,
    y2: 51.2755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 15.3988,
    y1: 35.5605,
    x2: 9.87257,
    y2: 41.0559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 50.47,
    y1: 61.8883,
    x2: 50.9489,
    y2: 63.6829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3591,
    stopColor: "#FDC5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7611,
    stopColor: "#FBAE98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 9.8971,
    y1: 63.3938,
    x2: 38.0942,
    y2: 80.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 35.1403,
    y1: 61.7259,
    x2: 28.9155,
    y2: 55.3646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 36,
    y1: 67.9169,
    x2: 36,
    y2: 71.9874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D07972"
  })))));
}

export default SvgSupplier;